import { z } from 'zod';

export const swEnvSchema = {
  client: {
    NEXT_PUBLIC_FIREBASE_API_KEY: z.string(),
    NEXT_PUBLIC_FIREBASE_PROJECT_ID: z.string(),
    NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID: z.string(),
    NEXT_PUBLIC_FIREBASE_APP_ID: z.string(),
  },
  shared: {
    NODE_ENV: z.enum(['development', 'production']).default('production'),
  },
};
